import { RootState } from 'redux/store';
import { createSelector } from 'reselect';
import { ILookup } from '../../../@types/profile-types';

const emailLookupState = (state: RootState) => state.profileLookups.emailLookup;

const selectEmailLookupState = createSelector([emailLookupState], (state) => {
    return state;
});

export const selectEmailLookupLoading = createSelector(selectEmailLookupState, (state) => {
    return state.loading;
});

export const selectEmailLookupData = createSelector(selectEmailLookupState, (state) => {
    const copy: ILookup[] = JSON.parse(JSON.stringify(state.data));
    copy.push({ value: 'other', display: 'Other' });
    return copy;
});

export const selectEmailLookupError = createSelector(selectEmailLookupState, (state) => {
    return state.error;
});
